// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607081104/js/" + chunkId + "." + {"44":"29df1673","225":"d70acce1","481":"17651e23","486":"2fd0bfbe","770":"79adc82e"}[chunkId] + ".0.35212103629754754.chunk.js";
};